import { render, staticRenderFns } from "./o-button.vue?vue&type=template&id=719933e7&"
import script from "./o-button.js?vue&type=script&lang=js&"
export * from "./o-button.js?vue&type=script&lang=js&"
import style0 from "./o-button.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports